
import React from "react";
import Navbar from "../components/Navbar";
import desktopBg from "../assets/Homepage/Banner_Desktop.png";
import mobileBg from "../assets/Homepage/Banner_Mobile.png";
import IntroductionSection from "../components/contents/Intro";
import FounderSection from "../components/contents/FounderSection";
import HomeserviceSection from "../components/contents/HomeServices";
import WhychooseusSection from "../components/contents/Whychooseus";
import GallarySection from "../components/contents/Gallary";
import FacilitySection from "../components/contents/FacilitySection";
import TestimonialsSection from "../components/contents/Testimonials";


import RoundedArrowButton from "../components/RoundedArrowButton"

export default function Home() {
  return (
    <>
      <div className="min-h-screen  bg-gray-900">
        {/* Navbar */}
        <Navbar />

        {/* Hero */}
        <header className="relative w-full ">
          {/* Background images */}
          <img
            src={desktopBg}
            alt=""
            className="hidden md:block absolute inset-0 w-full h-full object-cover"
            draggable="false"
          />
          <img
            src={mobileBg}
            alt=""
            className="md:hidden absolute inset-0 w-full h-full object-cover"
            draggable="false"
          />

          {/* Content container */}
          <div
            className="
              relative z-10 h-full 
              grid grid-cols-12
              md:mx-[75px] 
              md:gap-[20px]
              mx-[24px] 
              gap-[12px]
            "
          >
            {/* Row 1 - Headline */}
            <div
              className="
                col-span-12 md:col-span-9 
                flex items-start 
                 pt-[176px] md:pt-[176px]
              "
            >
              <h1 className="font-garamond-heading text-white">
                A New Beginning
                 <br />for a Healthier
                <br />
                
              
                Tomorrow
              </h1>
            </div>

            {/* Row 2 - Description */}
            <div className="col-span-12 md:col-span-5 md:col-start-8 mt-6 md:mt-0 border-t border-white/40">
              <div className="text-white md:py-8 py-6 ">
                <p className="font-generalsans-description font-normal md:text-[20px] sm:text-[14px] leading-[110%]">
                  At Arambh Rehab, we believe every journey to recovery starts
                  with a single step. Our compassionate team, holistic programs,
                  and safe, supportive environment empower individuals to
                  overcome addiction and rediscover the joy of living.
                </p>
              </div>

              {/* Contact button for mobile */}
              <div className="md:hidden mb-4 mt-4">
               
                <RoundedArrowButton label="Contact Us" to="/contact" />
              </div>
            </div>
          </div>
        </header>

        {/* Introduction Section */}
        <div className="bg-white">
          <IntroductionSection />
        </div>
      </div>

      {/* Founder Section */}
      <div className="bg-white">
        <FounderSection />
      </div>

      {/* Homeservice Section */}
      <div>
        <HomeserviceSection />
      </div>

      {/* Whychooseus Section */}
      <div className="bg-white">
        <WhychooseusSection />
      </div>

      {/* Gallary Section */}
      <div className="bg-white">
        <GallarySection />
      </div>
      {/* Facility Section */}
      <div className="bg-white">
        <FacilitySection />
      </div>

      {/* Testimonials Section */}
      <div className="bg-white">
        <TestimonialsSection />
      </div>
    </>
  );
}
